import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import { Types as TypesSnackbar } from '../../snackbarUseCase/actions';
import { Types as TypesInformation } from '../../procedures/getProcedureInformation/actions';
import BseRepository from '../../../repositories/BseRepository';
import BseDataRepository from '../../../../data/repositories/BseDataRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.REGISTER_BSE_REQUEST });
    const scholarshipsBseRepository: BseRepository = new BseDataRepository();

    XCheckpointManager.registerStart('BSE - Guardar datos');
    const registerBseResponse = yield call(
      scholarshipsBseRepository.registerBse,
      action.operationNumber,
      action.origin,
      action.fields,
      action.UT
    );
    XCheckpointManager.registerEnd('BSE - Guardar datos');
    if (!registerBseResponse) {
      yield put({
        type: Types.REGISTER_BSE_FAILURE,
        error: 'No se pudo registrar'
      });
      yield put({
        type: TypesSnackbar.TOGGLE_SNACKBAR_OPEN
      });
      return;
    }

    if (registerBseResponse?.error) {
      yield put({
        type: Types.REGISTER_BSE_FAILURE,
        operationNumber: registerBseResponse?.operationNumber,
        error:
          registerBseResponse?.error ||
          'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
      });
      yield put({
        type: TypesSnackbar.TOGGLE_SNACKBAR_OPEN
      });
      return;
    }

    yield put({
      type: TypesInformation.GET_PROCEDURE_INFORMATION_CLEAR
    });
    yield put({
      type: Types.REGISTER_BSE_SUCCESS,
      operationNumber: registerBseResponse?.operationNumber
    });
    yield put({
      type: TypesSnackbar.TOGGLE_SNACKBAR_OPEN
    });
  } catch (error) {
    yield put({
      type: Types.REGISTER_BSE_FAILURE,
      error:
        'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
    });
    yield put({
      type: TypesSnackbar.TOGGLE_SNACKBAR_OPEN
    });
  }
}
